let footerLoading = false;

const FOOTER_CACHE_KEY = "loadedFooter";
const FOOTER_CACHE_TTL = 1 * 60 * 60 * 1000; // 24 hodin

function getCachedFooter() {
  try {
    const raw = localStorage.getItem(FOOTER_CACHE_KEY);
    if (!raw) return null;
    const { html, ts } = JSON.parse(raw);
    if (!html || Date.now() - ts > FOOTER_CACHE_TTL) return null;
    return html;
  } catch {
    return null;
  }
}

function setCachedFooter(html) {
  try {
    localStorage.setItem(FOOTER_CACHE_KEY, JSON.stringify({ html, ts: Date.now() }));
  } catch {
    // localStorage může být plný / zakázaný (private mode) - v tom případě prostě necachujeme
  }
}

function fetchFooter(callback) {
  $.ajax({
    type: "GET",
    dataType: "html",
    url: "/",
    success: function (e) {
      var a = shoptet.common.createDocumentFromString(e),
        t = $(a).find("footer#footer").html();
      if (t) {
        $(".overall-wrapper").append('<footer id="footer">' + t + "</footer>");
        setCachedFooter(t);
      }
      footerLoading = false;
      callback();
    },
    error: function () {
      // původní kód tohle neřešil - při chybě požadavku zůstalo footerLoading natrvalo true
      // a callback se už nikdy nezavolal (deadlock pro cokoliv, co na footer čeká)
      footerLoading = false;
      callback();
    },
  });
}

function loadFooter(callback) {
  if ($("footer#footer").length || footerLoading) {
    callback();
    return;
  }

  footerLoading = true;

  const cached = getCachedFooter();
  if (cached) {
    $(".overall-wrapper").append('<footer id="footer">' + cached + "</footer>");
    footerLoading = false;
    callback();
    return;
  }

  // Nechceme, aby stahování + parsování celé homepage soutěžilo o výkon
  // s počátečním vykreslením stránky - odložíme to na chvíli, kdy má prohlížeč volno.
  const run = () => fetchFooter(callback);
  if ("requestIdleCallback" in window) {
    requestIdleCallback(run, { timeout: 1500 });
  } else {
    setTimeout(run, 0);
  }
}

$(document).on("cbox_closed", function () {
  $("#colorbox #cboxContent").removeAttr("style");
});

function checkHeight() {
  const $el = $(".cart-widget-products");
  $el.toggleClass("scrollbar", $el.outerHeight() > 359);
}

function checkCartState() {
  const $cartCount = $('i[data-testid="headerCartCount"]');

  if (!$cartCount.length || parseInt($cartCount.text(), 10) < 1) {
    $("#cart-widget").addClass("empty").removeClass("loader-wrapper");
    return;
  }
  $("#cart-widget").removeClass("empty");
  $('a[data-target="cart"]').addClass("full");
}

document.addEventListener("ShoptetDOMCartContentLoaded", function () {
  checkCartState();
  checkHeight();
});
document.addEventListener("ShoptetDOMAdvancedOrderLoaded", function () {
  checkCartState();
  checkHeight();
});
$(document).ready(function () {
  checkCartState();
});
document.addEventListener("ShoptetCartUpdated", function () {
  checkCartState();
  checkHeight();
});
